// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0.5em;
  background-color: #141414;
  color: white;
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  margin-bottom: 0.5em;
}

h1 {
  font-size: 200%;
  color: #def;
}

h2 {
  font-size: 150%;
  color: #cde;
}

h3 {
  font-size: 130%;
  color: #bcd;
}

h4 {
  font-size: 120%;
  color: #abc;
}

h5 {
  font-size: 115%;
  color: #9ab;
}

h6 {
  font-size: 110%;
  color: #89a;
}

hr {
  border: 0;
  height: 1px;
  background-color: #505050;
}

table {
  border-collapse: collapse;
}

table th {
  color: #abc;
}

table th, table td {
  text-align: left;
  vertical-align: top;

  padding-right: 1em;
  margin: 0;
  border: 0;
}

table td.nowrap {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.appNav li {
  display: inline;
  list-style: none;
  margin-right: 1.5em;
}

.App {
  font-size: 11pt;
}

.App-header {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.centeredContainer {
	display: flex;
	align-items: center;
	justify-content:center;
	text-align: center;
}

.spacedFormGroup {
	margin: 1em 0;
}

.spacedFormGroup label {
	display: block;
	margin-top: 0.5em;
}

a {
  color: #61dafb;
  text-decoration: none;
}

a:hover {
  color: #81faff;
}

button.link {
  background-color: transparent;
  color: #61dafb;
  border: none;
  cursor: pointer;
  display: inline;
  font-size: 100%;
  margin: 0;
  padding: 0;
}

button.link:hover {
  color: #81faff;
}

table.nowrapTable td, table.nowrapTable th {
  text-overflow: ellipsis;
  white-space: nowrap;
}

.org-context-selector {
	display: flex;
	gap: 0.25em;
	align-items: center;
}

.org-context-selector select {
	background-color: #282c34;
	color: white;
	border: 1px solid #505050;
	padding: 0.25em;
	border-radius: 4px;
}

.settings-container {
	display: flex;
	gap: 0.75em;
}

.settings-nav-group-header {
	font-size: 120%;
	font-weight: bold;
	margin-top: 1em;
}

.settings-nav-container {
	flex-shrink: 0;
	width: 200px;
	border-right: 1px solid #505050;
}

.settings-nav-list {
	display: flex;
	flex-direction: column;
	gap: 0.5em;
}

.settings-nav-list li {
	list-style: none;
}

.settings-content-container {
	flex-grow: 1;
}

.spinner {
	border: 4px solid #505050;
	border-top: 4px solid #61dafb;
	border-radius: 50%;
	width: 24px;
	height: 24px;
	animation: spin 1s linear infinite;
	margin: auto;
}

@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;;EAEnB,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,eAAe;EACf,eAAe;EACf,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,yBAAyB;CACzB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,+BAA+B;AAChC;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,6BAA6B;CAC7B,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,kCAAkC;CAClC,YAAY;AACb;;AAEA;CACC,KAAK,uBAAuB,EAAE;CAC9B,OAAO,yBAAyB,EAAE;AACnC","sourcesContent":["body {\n  margin: 0;\n  padding: 0.5em;\n  background-color: #141414;\n  color: white;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin: 0;\n  margin-bottom: 0.5em;\n}\n\nh1 {\n  font-size: 200%;\n  color: #def;\n}\n\nh2 {\n  font-size: 150%;\n  color: #cde;\n}\n\nh3 {\n  font-size: 130%;\n  color: #bcd;\n}\n\nh4 {\n  font-size: 120%;\n  color: #abc;\n}\n\nh5 {\n  font-size: 115%;\n  color: #9ab;\n}\n\nh6 {\n  font-size: 110%;\n  color: #89a;\n}\n\nhr {\n  border: 0;\n  height: 1px;\n  background-color: #505050;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\ntable th {\n  color: #abc;\n}\n\ntable th, table td {\n  text-align: left;\n  vertical-align: top;\n\n  padding-right: 1em;\n  margin: 0;\n  border: 0;\n}\n\ntable td.nowrap {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.appNav li {\n  display: inline;\n  list-style: none;\n  margin-right: 1.5em;\n}\n\n.App {\n  font-size: 11pt;\n}\n\n.App-header {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.centeredContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content:center;\n\ttext-align: center;\n}\n\n.spacedFormGroup {\n\tmargin: 1em 0;\n}\n\n.spacedFormGroup label {\n\tdisplay: block;\n\tmargin-top: 0.5em;\n}\n\na {\n  color: #61dafb;\n  text-decoration: none;\n}\n\na:hover {\n  color: #81faff;\n}\n\nbutton.link {\n  background-color: transparent;\n  color: #61dafb;\n  border: none;\n  cursor: pointer;\n  display: inline;\n  font-size: 100%;\n  margin: 0;\n  padding: 0;\n}\n\nbutton.link:hover {\n  color: #81faff;\n}\n\ntable.nowrapTable td, table.nowrapTable th {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.org-context-selector {\n\tdisplay: flex;\n\tgap: 0.25em;\n\talign-items: center;\n}\n\n.org-context-selector select {\n\tbackground-color: #282c34;\n\tcolor: white;\n\tborder: 1px solid #505050;\n\tpadding: 0.25em;\n\tborder-radius: 4px;\n}\n\n.settings-container {\n\tdisplay: flex;\n\tgap: 0.75em;\n}\n\n.settings-nav-group-header {\n\tfont-size: 120%;\n\tfont-weight: bold;\n\tmargin-top: 1em;\n}\n\n.settings-nav-container {\n\tflex-shrink: 0;\n\twidth: 200px;\n\tborder-right: 1px solid #505050;\n}\n\n.settings-nav-list {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.5em;\n}\n\n.settings-nav-list li {\n\tlist-style: none;\n}\n\n.settings-content-container {\n\tflex-grow: 1;\n}\n\n.spinner {\n\tborder: 4px solid #505050;\n\tborder-top: 4px solid #61dafb;\n\tborder-radius: 50%;\n\twidth: 24px;\n\theight: 24px;\n\tanimation: spin 1s linear infinite;\n\tmargin: auto;\n}\n\n@keyframes spin {\n\t0% { transform: rotate(0deg); }\n\t100% { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
